import clsx from "clsx"
import { FC } from "react"
import { LinkText } from "@/text"
import { Check } from "iconoir-react"
import InputEl from "./InputEl"
import { RadioCheckboxElProps } from "./types"

const RadioCheckboxEl: FC<RadioCheckboxElProps> = ({
  id,
  type,
  label,
  htmlLabel,
  className,
  validationText,
  theme,
  ...props
}) => (
  <div className={className}>
    <span className="relative mr-2 inline-block align-middle">
      <InputEl
        id={id}
        aria-label={label}
        type={type}
        theme={theme}
        className={clsx(
          "peer cursor-pointer appearance-none border-2 bg-transparent !p-1.5 h-5 w-5",
          theme === "light" && "border-grey-0 checked:bg-grey-0",
          theme === "dark" && "border-grey-900 checked:bg-grey-900",
          type === "radio" && "rounded-full"
        )}
        {...props}
      />
      {type === "checkbox" && (
        <Check
          width="14"
          height="14"
          className={clsx(
            "pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 transition-opacity duration-150",
            theme === "light" && "text-grey-900",
            theme === "dark" && "text-grey-0",
            "peer-checked:opacity-100"
          )}
        />
      )}
    </span>
    <LinkText as="label" htmlFor={id} className="cursor-pointer">
      {htmlLabel || label}
    </LinkText>
    {validationText && <div className="pt-1">{validationText}</div>}
  </div>
)

export default RadioCheckboxEl
